// TODO: Migrate to use @shopexperts/shared useMediaUploadIntegration
// This local version can be removed once all usages are updated

import { useMediaUploadMutation } from "./useMediaUploadMutation";
import { useMediaUploadMultipleMutation } from "./useMediaUploadMultipleMutation";
import { useMediaDeleteTemporaryMutation } from "./useMediaDeleteTemporaryMutation";
import { useMediaDeleteMutation } from "./useMediaDeleteMutation";

interface MediaItem {
  file?: File;
  url?: string;
  media_id?: string;
  filename?: string;
  metadata?: Record<string, unknown>;
  uploadedAt?: Date | string;
  isTemporary?: boolean;
}

interface MediaData {
  id: string;
  cdn_url: string;
  filename?: string;
  metadata?: Record<string, unknown>;
}

export function useMediaUploadIntegration() {
  const uploadMutation = useMediaUploadMutation();
  const uploadMultipleMutation = useMediaUploadMultipleMutation();
  const deleteTemporaryMutation = useMediaDeleteTemporaryMutation();
  const deleteMutation = useMediaDeleteMutation();

  async function uploadFn(
    file: File,
    collection: string,
    metadata?: object
  ) {
    const response = await uploadMutation.mutateAsync({
      file,
      collection,
      metadata: metadata as Record<string, unknown>,
    });
    
    return {
      id: response.id,
      url: response.cdn_url,
      filename: response.filename,
      metadata: response.metadata,
    };
  }

  async function deleteFn(item: MediaItem) {
    if (!item.media_id) {
      console.warn("[useMediaUploadIntegration] Cannot delete item without media_id");
      return;
    }

    if (item.isTemporary) {
      await deleteTemporaryMutation.mutateAsync(item.media_id);
    } else {
      await deleteMutation.mutateAsync(item.media_id);
    }
  }

  async function uploadMultipleFn(
    files: File[],
    collection: string,
    metadata?: object
  ) {
    const response = await uploadMultipleMutation.mutateAsync({
      files,
      collection,
      metadata: metadata as Record<string, unknown>,
    });
    
    return response.map((media: MediaData) => ({
      id: media.id,
      url: media.cdn_url,
      filename: media.filename,
      metadata: media.metadata,
    }));
  }

  return {
    uploadFn,
    deleteFn,
    uploadMultipleFn,
    isUploading: uploadMutation.isPending,
    isUploadingMultiple: uploadMultipleMutation.isPending,
    isDeleting: deleteTemporaryMutation.isPending || deleteMutation.isPending,
  };
}
